import { render, staticRenderFns } from "./ImpersonatedNotification.vue?vue&type=template&id=4d6c61e7"
import script from "./ImpersonatedNotification.vue?vue&type=script&lang=js"
export * from "./ImpersonatedNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports